import React from 'react'
import { useHistory, useLocation } from 'react-router-dom'
import GridViewIcon from '@mui/icons-material/GridView'
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart'
import { t } from 'i18next'
import { useCustomerDisplay } from '../../context/CustomerDisplayContext'
import cochez from '../../assets/cochez.svg'
import novey from '../../assets/novey.svg'
import { CUSTOMER_DISPLAY_ROUTES } from '../../utils/customerDisplayRoutes'
import './navBar.css'

export default function NavBar({ company, showNavigation = false }) {
  const history = useHistory()
  const location = useLocation()
  const { listProducts, productsCart } = useCustomerDisplay()

  const cartItemCount = productsCart?.length || 0
  const hasProducts = listProducts?.length > 0
  const isCartEnabled = cartItemCount > 0
  const isOnSearchPage = location.pathname === CUSTOMER_DISPLAY_ROUTES.search
  const isOnCartPage = location.pathname === CUSTOMER_DISPLAY_ROUTES.cart

  const handleNavigateToProducts = () => {
    if (hasProducts && !isOnSearchPage) {
      history.push(CUSTOMER_DISPLAY_ROUTES.search)
    }
  }

  const handleNavigateToCart = () => {
    if (isCartEnabled && !isOnCartPage) {
      history.push(CUSTOMER_DISPLAY_ROUTES.cart)
    }
  }

  const navbarColorClass =
    company === 'CO'
      ? 'color-navbar-cochez'
      : company === 'NO'
      ? 'color-navbar-novey'
      : 'color-navbar-cochez'

  const logoSrc = company === 'CO' ? cochez : company === 'NO' ? novey : cochez

  return (
    <div className={`navbar-product-search ${navbarColorClass}`}>
      <img src={logoSrc} alt="Logo" className="navbar-logo" />

      {showNavigation && (
        <div className="navbar-navigation">
          <button
            type="button"
            data-testid="btn-customer-display-products"
            className={`navbar-nav-button ${isOnSearchPage ? 'active' : ''} ${
              !hasProducts ? 'disabled' : ''
            }`}
            onClick={handleNavigateToProducts}
            disabled={!hasProducts}
            aria-current={isOnSearchPage ? 'page' : undefined}>
            <GridViewIcon />
            <span>{t('CUSTOMER_DISPLAY.NAV_PRODUCTS')}</span>
          </button>

          <button
            type="button"
            data-testid="btn-customer-display-cart"
            className={`navbar-nav-button ${isOnCartPage ? 'active' : ''} ${
              !isCartEnabled ? 'disabled' : ''
            }`}
            onClick={handleNavigateToCart}
            disabled={!isCartEnabled}
            aria-current={isOnCartPage ? 'page' : undefined}>
            <div className="navbar-cart-icon-wrapper">
              <ShoppingCartIcon />
              {cartItemCount > 0 && (
                <span
                  className="navbar-cart-badge"
                  data-testid="text-customer-display-cart-count">
                  {cartItemCount}
                </span>
              )}
            </div>
            <span>{t('CUSTOMER_DISPLAY.NAV_CART')}</span>
          </button>
        </div>
      )}
    </div>
  )
}
